export const API_ROOT_URL = 'https://prod.imagine.io';

export const GET_SCENE_LABEL_PUBLIC_API = '/configurator/api/v2/sceneoption-public-data/';
export const GET_LABEL_OPTIONS_PUBLIC_API = '/configurator/api/v2/scenetexture-public-data/';
export const GET_PROTOTYPE_PREVIEWS_API = '/configurator/api/v2/update-scene-texture-render/';
export const GET_SCENE_VIEW_BG_INFO_PUBLIC_API = '/configurator/api/v2/scene-view-background-info-public/';

// render & preview//
export const GET_RENDER_PREVIEW = '/rendering-system/api/v3/project-render-images/';
export const GET_DOWNLOAD_RENDER_IMAGES = '/rendering-system/api/v3/lambda/download-renders/';
export const GET_RENDER_DATA = '/rendering-system/api/v3/get-render/';
export const RENDER_PARTIAL_PAYMENT = '/rendering-system/api/v3/render-partial-payment-detail/';

export const GET_RENDER_STORE_LIST = '/configurator/api/v2/get-render-store/';
export const REORDER_VIEWS = '/configurator/api/v2/multiple-sceneview-seq-update/';
export const CONFIG_PUBLIC_LINK = 'configurator/api/config-public-link/';
// export const CONFIG_PUBLIC_DATA = 'configurator/api/v2/config-public-data/';
export const CONFIG_PUBLIC_DATA = 'configurator/api/v2/v3/config-public-data/';
export const GET_LABEL_OPTIONS_API = '/configurator/api/v2/scene-texture/';
export const GET_SCENE_PUBLIC_DATA = 'configurator/api/v2/all-scene-public-data/';
export const CHECK_FOR_UNICODE = '';
